let isMathjaxConfig = false; //用于标识是否配置
const initMathjaxConfig = () => {
  if (!window.MathJax) {
    return;
  }
  window.MathJax.Hub.Config({
    showProcessingMessages: false,
    messageStyle: "none",
    tex2jax: {
      inlineMath: [
        ["$", "$"],
        ["\\(", "\\)"],
        ["[data-latex]", "[/data-latex]"],
      ],
      displayMath: [
        ["$$", "$$"],
        ["\\[", "\\]"],
      ],
      processEscapes: true,
    },
    TeX: {
      extensions: ["AMSmath.js", "AMSsymbols.js"],
      equationNumbers: {
        autoNumber: ["AMS"],
        useLabelIds: true,
      },
      Macros: { hfill: "{}" },
    },
    "HTML-CSS": {
      linebreaks: { automatic: true },
      availableFonts: ["TeX"],
      scale: 110,
    },
    SVG: {
      linebreaks: {
        automatic: true,
      },
    },
    showMathMenu: false,
  });
  isMathjaxConfig = true; //配置完成，改为true
};
const MathQueue = function (elementId) {
  if (!window.MathJax) {
    return;
  }
  window.MathJax.Hub.Queue([
    "Typeset",
    window.MathJax.Hub,
    document.getElementById(elementId),
  ]);
};

export default {
  isMathjaxConfig,
  initMathjaxConfig,
  MathQueue,
};
